import React, { useContext } from "react";
import { NavLink, Route } from "react-router-dom";
// import Cookies from 'js-cookie';
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import { Button, WindmillContext } from "@windmill/react-ui";
import { IoLogOutOutline } from "react-icons/io5";
import logoDark from "../../../admin/assets/img/logo/logo-dark.svg";
import logoLight from "../../../admin/assets/img/logo/logo-light.svg";
import language from "../../../language";
import sidebar from "../../routes/sidebar";
import './Sidebaar.css'

import { AdminContext } from "../../../admin/context/AdminContext";
import { useHistory } from 'react-router-dom';
import { resetUserdataOperator } from "../../../Redux/userReducer";
import { useDispatch } from "react-redux";

const SidebarContent = () => {
    const cookies = new Cookies();
    const history = useHistory();
    let languageSelectedEnglish =
        sessionStorage.getItem("language") === "english" ||
            !sessionStorage.getItem("language")
            ? true
            : false;
    const isLogin = cookies.get("auth");
    const { mode } = useContext(WindmillContext);
    const dispatch = useDispatch();

    const handleLogOut = () => {
        Swal.fire({
            icon: "warning",
            title: "",
            text: "You want to SignOut!",
            showCancelButton: true,
            confirmButtonText: "Yes, sign out!",
            cancelButtonText: "Cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(dispatch(resetUserdataOperator()))
                history.push("/")

            }
        });
    };

    return (
        <div className="py-4 text-gray-500 sidebarContent">
            <div className=" text-gray-900" style={{ textDecoration: "underline" }}>
                <h1 style={{ marginLeft: "1.5rem", fontSize: "1.3rem" }}>
                    {languageSelectedEnglish ? "User Panel" : language.adminPanel}
                </h1>
            </div>
            <ul className="mt-8 tabsList">
                {sidebar.map((route) => (
                    <li className="relative" key={route.name}>
                        <NavLink
                            exact
                            to={route.path}
                            className="px-6 py-4 inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-green-700"
                            activeClassName="text-green-500"
                        >
                            <Route path={route.path} exact={route.exact}>
                                <span
                                    className="absolute inset-y-0 left-0 w-1 bg-green-500 rounded-tr-lg rounded-br-lg addBusBtnHomeIndi"
                                    aria-hidden="true"
                                ></span>
                            </Route>
                            <route.icon className="w-5 h-5" aria-hidden="true" />
                            <span className="ml-4">{route.name}</span>
                        </NavLink>
                    </li>
                ))}
            </ul>
            <span className="lg:fixed bottom-0 px-6 py-6 w-64 mx-auto relative mt-3 block">
                <Button
                    onClick={handleLogOut}
                    size="large"
                    className="w-full addBusBtnHome logNew"
                >
                    <span className="flex items-center">
                        <IoLogOutOutline
                            className="mr-3 text-lg"
                        />
                        <span className="text-sm">
                            {languageSelectedEnglish ? "Log out" : language.logout}
                        </span>
                    </span>
                </Button>
            </span>
        </div>
    );
};

export default SidebarContent;
